'use client';

import type {
  GetLoyaltyEntitlementConsentEntitlementTypeEnum,
  LoyaltyEntitlementStatus,
} from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import type { ReactNode } from 'react';
import { useMemo, createContext } from 'react';

export type LoyaltyEntitlementContextType = {
  entitlementEnum: GetLoyaltyEntitlementConsentEntitlementTypeEnum;
  status: LoyaltyEntitlementStatus;
  shortName: string;
};

export const LoyaltyEntitlementContext = createContext<LoyaltyEntitlementContextType | null>(null);

export interface LoyaltyEntitlementProviderProps extends LoyaltyEntitlementContextType {
  children: ReactNode;
}

export const LoyaltyEntitlementProvider = ({
  children,
  entitlementEnum,
  shortName,
  status,
}: LoyaltyEntitlementProviderProps) => {
  const value = useMemo(
    () => ({ entitlementEnum, shortName, status }),
    [entitlementEnum, shortName, status],
  );

  return (
    <LoyaltyEntitlementContext.Provider value={value}>
      {children}
    </LoyaltyEntitlementContext.Provider>
  );
};
